import {api, router, store} from 'macarons'
import Admin from './Admin.vue'
import Carousel from './Carousel.vue'
import Post from './Post.vue'

export default {
  install (Vue, {withMenu = true, anonymousBlogWidgets = false}) {
    router.addRoutes([{
      path: '/blog-admin',
      component: Admin
    }])

    if (withMenu) {
      store.commit('menu/registerItem', {
        path: '/blog-admin',
        title: 'Gestion du blog'
      })
    }

    store.commit('registerWidget', {
      label: 'Blog',
      id: 'blog',
      component: Carousel
    })

    const loadWidgets = () => api.get('blog/widgets').then(response => {
      if (Array.isArray(response.data)) {
        response.data.forEach(widget => {
          store.commit('registerWidget', {
            label: widget.title,
            id: 'blog-post-' + widget.id,
            component: Post,
            options: {
              widget: widget
            }
          })
        })
      }
    })

    if (anonymousBlogWidgets) {
      loadWidgets()
    }
    
    store.watch(state => {
      return state.token
    }, () => {
      if (store.state.token) {
        loadWidgets()
      }
    })
  }
}



// WEBPACK FOOTER //
// ./node_modules/macarons-blog/index.js